import { LOAD_CALENDARS, SHOW_CALENDAR, HIDE_CALENDAR, TOGGLE_CALENDAR } from 'constants/ActionTypes';

const calendars = (state = { list: null, displayed: null }, action) => {
  switch (action.type) {
    case LOAD_CALENDARS:
      return {
        ...state,
        list: action.payload,
        displayed: state.displayed || Object.keys(action.payload).map(id => +id)
      };

    case SHOW_CALENDAR: {
      return {
        ...state,
        displayed: [
          ...state.displayed,
          +action.payload
        ]
      }
    }

    case HIDE_CALENDAR: {
      return {
        ...state,
        displayed: state.displayed.filter(id => id !== +action.payload)
      }
    }

    case TOGGLE_CALENDAR: {
      return {
        ...state,
        displayed: state.displayed.indexOf(+action.payload) === -1 ? [
          ...state.displayed,
          +action.payload
        ] : state.displayed.filter(id => id !== +action.payload)
      }
    }

    default:
      return state;
  }
};

export default calendars;


// WEBPACK FOOTER //
// ./reducers/Calendars.js